import './App.scss';

import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';

import { ROUTES } from './App.routes';
import { NotesList } from './components/notes-list/notes-list';
import { APP_NAME } from './constants/config';

function App() {
  return (
    <div className="app">
      <header className="app-header">
        <Link to="/">{APP_NAME}</Link>
      </header>
      <aside className="app-sidenav">
        <NotesList />
      </aside>
      <main className="app-main">
        <Switch>
          {ROUTES.filter((route) => route.children).map((route, idx) => (
            <Route
              key={idx}
              exact={route.exact}
              path={route.path}
              children={route.children}
            />
          ))}
        </Switch>
      </main>
      <footer className="app-footer">
        <span className="copyleft" title="copyleft"></span>
      </footer>
    </div>
  );
}

export default App;
